import {
    Alert,
    Box,
    TableContainer,
    Table,
    TableBody,
    TableHead,
    Typography,
    TableRow,
    TableCell,
    Chip,
} from "@mui/material";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import InstitutionDetailsStyle from "./style";
import InstitutionDevices from "./devices";

import DashboardContent from "@/components/app/DashboardContent";
import DashboardHeader from "@/components/app/DashboardHeader";
import { useInstitutionById } from "@/api/hooks/institution";
import { InstitutionStatus } from "@/api/types/institution";

const STATUS_COLOR: Record<InstitutionStatus, "success" | "warning" | "error"> = {
    active: "success",
    suspended: "warning",
    expired: "error",
};

export default function InstitutionDetails() {
    const { id } = useParams();

    const { data: InstitutionResult } = useInstitutionById(Number(id));
    const InstitutionData = InstitutionResult?.data;

    return (
        <InstitutionDetailsStyle>
            <DashboardHeader title="Institution Details">
                <Alert severity="info" sx={{ marginTop: "1em" }}>
                    See the details of this institution and manage its devices!
                </Alert>
            </DashboardHeader>

            <DashboardContent>
                <Box>
                    <Typography className="title" variant="h5">
                        Details of Institution {id}
                    </Typography>
                    <br />
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className="table-header">Name</TableCell>
                                    <TableCell className="table-header">Email</TableCell>
                                    <TableCell className="table-header">Max Devices</TableCell>
                                    <TableCell className="table-header">Status</TableCell>
                                    <TableCell className="table-header">Start Date</TableCell>
                                    <TableCell className="table-header">End Date</TableCell>
                                    <TableCell className="table-header">Notes</TableCell>
                                    <TableCell className="table-header">Updated At</TableCell>
                                    <TableCell className="table-header">Created At</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell className="table-header">{InstitutionData?.name || "-"}</TableCell>
                                    <TableCell className="table-header">{InstitutionData?.email || "-"}</TableCell>
                                    <TableCell className="table-header">
                                        {InstitutionData?.maxConcurrentDevices ?? "-"}
                                    </TableCell>
                                    <TableCell className="table-header">
                                        {InstitutionData?.status ? (
                                            <Chip
                                                color={STATUS_COLOR[InstitutionData.status]}
                                                label={InstitutionData.status}
                                                size="small"
                                                variant="outlined"
                                            />
                                        ) : (
                                            "-"
                                        )}
                                    </TableCell>
                                    <TableCell className="table-header">
                                        {InstitutionData?.startDate
                                            ? dayjs(InstitutionData.startDate).format("YYYY-MM-DD")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className="table-header">
                                        {InstitutionData?.endDate
                                            ? dayjs(InstitutionData.endDate).format("YYYY-MM-DD")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className="table-header">{InstitutionData?.notes || "-"}</TableCell>
                                    <TableCell className="table-header">
                                        {InstitutionData?.updatedAt
                                            ? dayjs(InstitutionData.updatedAt).format("YYYY-MM-DD HH:mm")
                                            : "-"}
                                    </TableCell>
                                    <TableCell className="table-header">
                                        {InstitutionData?.createdAt
                                            ? dayjs(InstitutionData.createdAt).format("YYYY-MM-DD HH:mm")
                                            : "-"}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <br />
                <br />
                <Typography className="title" variant="h5">
                    Devices
                </Typography>
                <InstitutionDevices institutionId={Number(id)} />
            </DashboardContent>
        </InstitutionDetailsStyle>
    );
}
